// extracted by mini-css-extract-plugin
export default {"reactSlidedown":"slideUpDownContainer_reactSlidedown__EUTO8","transitioning":"slideUpDownContainer_transitioning__QT9A-","closed":"slideUpDownContainer_closed__Ikj7M"};